<template>
  <div v-if="data">
    <div class="clock">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b538553b722813d4873eb56f56639b32.png"
        alt=""
      />
      <div class="circle">
        <canvas id="clock-canvas"></canvas>
        <div class="clock-content">
          <div class="next-tips">距离下一次提醒，还有</div>
          <div class="time-out">{{ data.clockData.time | filterTime }}</div>
          <div class="tonic-swipe">
            <van-swipe
              v-if="data.curSwiperData"
              style="height: 100%"
              vertical
              autoplay="3000"
              :show-indicators="false"
            >
              <van-swipe-item
                v-for="(item, index) in data.curSwiperData.list"
                :key="index"
              >
                <div class="swipe-item">
                  <div class="tonic-name"
                    >{{ item.eat_hour | filterTimeFillZero }}:{{
                      item.eat_minute | filterTimeFillZero
                    }}
                    {{ item.p_title }}</div
                  >
                  <div class="tonic-num">
                    {{ item.every_times_num }}{{ item.min_unit_txt }}·{{
                      item.take_suggested_time_txt
                    }}
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div @click="bindEditPlan" class="edit-plan">修改计划</div>
        </div>
        <div class="tonic-images">
          <div
            class="tonic-image-item"
            :style="{ left: item.left * 100 + '%', top: item.top * 100 + '%' }"
            v-for="(item, index) in data.renderList"
            :key="index"
          >
            <div class="is-eat iconfont icon-gou" v-if="item.isEat"></div>
            <div class="item-content" v-if="item.list && item.list.length">
              <van-swipe
                v-if="item.isSwipe"
                class="tonic-swiper"
                autoplay="3000"
                :show-indicators="false"
              >
                <van-swipe-item
                  v-for="(item1, index1) in item.list"
                  :key="index1"
                >
                  <img class="tonic-image" :src="item1.p_image" alt="" />
                </van-swipe-item>
              </van-swipe>
              <div v-else>
                <div v-for="(item1, index1) in item.list" :key="index1">
                  <img
                    class="tonic-image"
                    v-show="index1 < 1"
                    :src="item1.p_image"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'create-conical-gradient'
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  filters: {
    filterTime(time) {
      let hours = Math.floor(time / (60 * 60))
      let min = Math.floor((time % (60 * 60)) / 60)
      let second = (time % (60 * 60)) % 60
      hours = hours > 9 ? hours : '0' + hours
      min = min > 9 ? min : '0' + min
      second = second > 9 ? second : '0' + second
      return hours + ':' + min + ':' + second
    },
    filterTimeFillZero(time) {
      return time > 9 ? time : '0' + time
    }
  },
  computed: {
    angle() {
      return this.data?.clockData.angle || 0
    }
  },
  watch: {
    'data.clockData.angle'() {
      this.write(this.data.clockData.angle)
    }
  },
  created() {},
  mounted() {
    this.init()
    this.write(this.data?.clockData.angle || 0)
  },
  methods: {
    bindEditPlan() {
      this.$emit('edit')
    },
    init() {
      this.lineWidth = 20
      const canvas = document.getElementById('clock-canvas')
      this.canvasWidth = canvas.clientWidth
      this.canvasHeight = canvas.clientHeight
      canvas.width = this.canvasWidth
      canvas.height = this.canvasHeight
      /** @type {CanvasRenderingContext2D} */
      this.ctx = canvas.getContext('2d')
      this.ctx.lineCap = 'round'
      this.ctx.lineWidth = this.lineWidth
      const gradient = this.ctx.createConicalGradient(
        this.canvasWidth / 2,
        this.canvasHeight / 2,
        -0.5 * Math.PI,
        1.5 * Math.PI
      )
      gradient.addColorStop(0, 'rgba(37, 255, 202, 1)')
      gradient.addColorStop(0.3, 'rgba(245, 229, 6, 1)')
      gradient.addColorStop(0.65, 'rgba(255, 145, 26, 1)')
      gradient.addColorStop(0.95, 'rgba(255, 97, 15, 1)')
      gradient.addColorStop(1, 'rgba(37, 255, 202, 1)')
      this.ctx.strokeStyle = gradient.pattern
      this.ctx.fillStyle = gradient.pattern
    },
    write(angle) {
      this.ctx.beginPath()
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      this.ctx.moveTo(this.canvasWidth / 2, this.lineWidth / 2)
      let startAngle = -0.5 * Math.PI
      let endAngle = startAngle + ((2 * Math.PI) / 360) * angle
      this.ctx.arc(
        this.canvasWidth / 2,
        this.canvasHeight / 2,
        (this.canvasWidth - this.lineWidth) / 2,
        startAngle,
        endAngle,
        false
      )
      this.ctx.stroke()
    }
  }
}
</script>
<style lang="scss" scoped>
.clock {
  width: 100%;
  height: 385px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.8);

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
  }

  .circle {
    position: absolute;
    left: 50%;
    top: 26px;
    transform: translate(-50%, 0%);
    z-index: 4;
    width: 317px;
    height: 317px;

    #clock-canvas {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
    }

    .clock-content {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 5;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .next-tips {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        line-height: 17px;
      }

      .time-out {
        width: 205px;
        text-align: center;
        padding-bottom: 6px;
        border-bottom: 1px solid rgba(52, 49, 79, 0.2);
        font-size: 44px;
        font-family: DINPro, DIN;
        font-weight: bold;
        line-height: 56px;
      }

      .tonic-swipe {
        width: 200px;
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        line-height: 17px;
        height: 56px;
        margin-bottom: 10px;

        .swipe-item {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .tonic-name {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          line-height: 17px;
        }

        .tonic-num {
          margin-top: 2px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
        }
      }

      .edit-plan {
        width: 87px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        font-size: 12px;
        color: rgba(0, 0, 0, 0.67);
        font-family: PingFangSC, PingFang SC;
      }
    }

    .tonic-images {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 3;
      width: 100%;
      height: 100%;

      .tonic-image-item {
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }

      .tonic-swiper {
        width: 100%;
        border-radius: 50%;
        overflow: hidden;
        transform: translate3d(0, 0, 0);
      }

      .is-eat {
        z-index: 2;
        width: 13px;
        height: 13px;
        background: #03d4e6;
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 0;
        color: #fff;
        font-size: 10px;
        justify-content: center;
        display: flex;
        align-items: center;
      }

      .item-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        overflow: hidden;
        background-color: #f9f9f9;
        border-radius: 50%;
        box-sizing: border-box;

        .tonic-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .item-content::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        box-sizing: border-box;
        border: 4px solid #fff;
      }
    }
  }
}
</style>
